import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import "./HomeMain.modul.scss";
import Chart from "./Chart/Chart";
import Information from "./Information/Information";
import { CommonAPImain } from "../../../../Utils/API/CommonAPImain/CommonAPImain";
import { homeLoading } from "../../../Recoil/atom";
import { useRecoilState } from "recoil";

const HomeMain = () => {
  const [isLoading, setIsLoading] = useRecoilState(homeLoading);

  return (
    <div style={{ paddingBottom: "0px" }}>
      {isLoading ? (
        <div className="loader-overlay">
          <CircularProgress className="loadingBarManage" />
        </div>
      ) : (
        <div className="homeMain_div">
          {/* <TargetEndAchievement /> */}
          <Chart />
          <Information />
        </div>
      )}
    </div>
  );
};

export default HomeMain;
